/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import DatePicker from '../../../components/datePicker';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { useLocales } from '../../../locales';
import { newConfigsMap } from './config';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { DEFAULT_RANGE } from '../../../components/datePicker/utils';
import PlatformHeatmapList from '../../../components/analytics/heatmapList';
import {
  ANALYTICS_NAVBAR_ACTIONS,
  BEST_TIME_TO_POST_LABEL,
  CAMPAIGN_ANALYTICS_LABEL,
  GROWTH_LABEL,
  OVERVIEW_LABEL,
  POST_PERFORMANCE_LABEL
} from '../../dashboard/config';
import AnalyticsPagesLayout from '../../../components/analyticsPagesLayout';
import {
  getAnalyticsForLocation,
  transferData
} from '../../../redux/slices/analytics/plotsData';
import NewPlotTabs from '../../../components/plotTabs/newPlotTabs';
import { getAllDates } from '../../../utils/dateUtils';
import { PINTEREST } from '../../../config/constants';
import { data } from './demoDataDocument';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { ANALYICS_FOR_SOCIAL_MEDIA } from '../../../config/firebase/collections';
import OverviewTab from '../shared/OverviewTab';
import BestTimeToPostTab from '../shared/BestTimeToPostTab';
import PostPerformance from '@/pages/allAnalytics/sections/postPerformance';
import GrowthTab from '../shared/GrowthTab';
import {
  pinterestFollowersGrowthConfig,
  pinterestPlatformsGrowthConfig,
  pinterestPlatformsGrowthPerDayConfig,
  pinterestPlatformsGrowthPerPostConfig
} from './growthConfig';
import CampaignAnalysis from '@/pages/allAnalytics/sections/campaignAnalytics';

const PinterestAnalyticsPage: React.FC = () => {
  const { isLoading, uuid, demo, platforms_information } = useSelector(
    (state: any) => state.locationDetails
  );
  console.log(platforms_information);
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  const [error, setError] = useState(false);
  const [loadingOld, setLoadingOld] = useState(true);
  const [oldPlotsData, setOldPlotsData] = useState(null);
  useEffect(() => {
    dispatch(getUserDetails() as unknown as AnyAction);
  }, [dispatch]);

  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);
  const [dates, setDates] = useState({
    ...DEFAULT_RANGE
  });

  const type = 'social_media_profile';
  const [plotsData, setPlotsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { translate: t } = useLocales();
  useEffect(() => {
    // ── 1. Demo mode ───────────────────────────────────────────────────────
    if (demo) {
      setPlotsData(data);
      setLoading(false);
      setLoadingOld(false);
      return;
    }

    // ── 2. Guard clauses ───────────────────────────────────────────────────
    if (!dates) return;
    // if(demo) {setPlotsData(transferData(demo, newConfigsMap)); return;}
    if (
      !isLoading &&
      uuid &&
      Object.keys(platforms_information).includes(PINTEREST)
    ) {
      setLoading(true);
      setError(false);
      getAnalyticsForLocation(
        ANALYICS_FOR_SOCIAL_MEDIA,
        type,
        platforms_information[PINTEREST]?.[0]?.uuid,
        dates,
        PINTEREST
      )
        .then((res) => {
          setPlotsData(transferData(res, newConfigsMap));
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setError(true);
          setLoading(false);
        });
    }
  }, [uuid, isLoading, dates]);
  if (isLoading) return <IsLoadingIndicator />;

  return (
    <Container>
      <AnalyticsPagesLayout
        actions={ANALYTICS_NAVBAR_ACTIONS}
        tabs={{
          [OVERVIEW_LABEL]: (
            <OverviewTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              loading={loading}
              error={error}
              newConfigsMap={newConfigsMap}
              platform={PINTEREST}
              followersGrowthConfig={pinterestFollowersGrowthConfig}
              platformsGrowthConfig={pinterestPlatformsGrowthConfig}
              dailyGrowthConfig={pinterestPlatformsGrowthPerDayConfig}
              contentGrowthConfig={pinterestPlatformsGrowthPerPostConfig}
            />
          ),
          [BEST_TIME_TO_POST_LABEL]: (
            <BestTimeToPostTab platforms={[PINTEREST]} />
          ),
          [POST_PERFORMANCE_LABEL]: <PostPerformance platform={PINTEREST} />,
          [GROWTH_LABEL]: (
            <GrowthTab
              dates={dates}
              setDates={setDates}
              plotsData={plotsData}
              newConfigsMap={newConfigsMap}
              error={error}
              loading={loading}
              show_data_import_info={false}
              locationslug={locationslug}
            />
          ),
          [CAMPAIGN_ANALYTICS_LABEL]: <CampaignAnalysis platform={PINTEREST} />
        }}
      />
    </Container>
  );
};
export default PinterestAnalyticsPage;
